import { withInstall } from '@vuesax-plus/utils'
import Option from './src/option.vue'

export const VsOption = withInstall(Option)
export default VsOption

export * from './src/option'
